import { Button } from '@/components/ui/button'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useFieldArray } from 'react-hook-form'

interface Props {
  name: string
  index: number
  totalLength: number
}

const OrderCell = ({ name, index, totalLength }: Props) => {
  const { move } = useFieldArray({ name })

  const isFirst = index === 0
  const isLast = index === totalLength - 1

  return (
    <div className='flex justify-end gap-1 mt-0.5'>
      <Button
        type='button'
        size='sm'
        variant='outline'
        disabled={isFirst}
        onClick={() => move(index, index - 1)}
        className='h-9 w-9 p-0'
      >
        <ChevronUp size={14} />
      </Button>
      <Button
        type='button'
        size='sm'
        variant='outline'
        disabled={isLast}
        onClick={() => move(index, index + 1)}
        className='h-9 w-9 p-0'
      >
        <ChevronDown size={14} />
      </Button>
    </div>
  )
}

export default OrderCell
